import FilialDetailsHeader from "./FilialDetailsHeader";
import FilialDetailsBody from "./FilialDetailsBody";
import styles from "../../styles/addInvoice.module.css";

export default function FilialDetails({
  invoiceData,
  updateField,
  errors = {},
}) {
  return (
    <div className={styles["invoice-details"]}>
      <FilialDetailsHeader />
      <FilialDetailsBody
        invoiceData={invoiceData}
        updateField={updateField}
        errors={errors}
      />
    </div>
  );
}
